import { render, staticRenderFns } from "./edit-industry-type.vue?vue&type=template&id=707bcd76&scoped=true&"
import script from "./edit-industry-type.vue?vue&type=script&lang=js&"
export * from "./edit-industry-type.vue?vue&type=script&lang=js&"
import style0 from "./edit-industry-type.vue?vue&type=style&index=0&id=707bcd76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707bcd76",
  null
  
)

export default component.exports